module.exports = __webpack_public_path__ + "img/欢聚.04730753.webp";